var __rspack_ns_object = JSON.parse('{"TITLE":"Artists","COMPANY_ARTISTS":{"EMPTY_STATE":{"MESSAGE":"No artists linked to this company yet."}}}')